/**
 * Outlined chart frame for the Executive View charts (ruled 2026-09-07): the same look as the Tornado answer's
 * outlined Card + CardContent p:3, expressed as sx so the chart panels can apply it to their chart block without
 * restructuring. The block it wraps is chart + legend + range picker; the data table below stays outside, so the
 * frame's outer edges line up with the table's edges. Analyst result cards never opt in.
 */
export const CHART_FRAME_SX = {
  border: 1,
  borderColor: 'divider',
  borderRadius: 1,
  bgcolor: 'background.paper',
  p: 3,
} as const;
